export default {"src":"/_next/static/media/setting.38b6aa88.svg","height":24,"width":24};